import moment from "moment-timezone";
import React from "react";
import PremiumAccess from "../PremiumAccess";
import { DEFAULT_TIMEZONE } from "src/constants";

// Render the back 2 back game boolean for basketball. Back 2 back game is the one where plays on 2nd day straight
const B2BCell = ({
  filteredSchedule,
  scheduleItem,
  freeGame,
}: {
  filteredSchedule: any;
  scheduleItem: any;
  freeGame: boolean;
}) => {
  // Use EST for this because most sports with B2B are American
  const previousDate = moment.tz(scheduleItem?.startDate, DEFAULT_TIMEZONE).subtract(1, "day").format("M/D/YYYY"); // prettier-ignore
  const b2b = filteredSchedule.some((schedule: any) => {
    return moment.tz(schedule?.startDate, DEFAULT_TIMEZONE).format("M/D/YYYY") === previousDate; // prettier-ignore
  });

  return (
    <PremiumAccess freeGame={freeGame} scheduleItem={scheduleItem} source="B2B Cell" graybar>
      <span className={`schedule-list__table-item-5 schedule-list__table-cell-${b2b ? "bad" : "good"}`}>
        {b2b ? "YES" : "NO"}
      </span>
    </PremiumAccess>
  );
};

export default B2BCell;
